<template>
  <div class="max-w-xl mx-auto px-8 mb-8">
    <div
      class="bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200 my-5 p-8"
    >
      <p class="pb-5 mb-5">
        Thank you for your order. To complete the order process please proceed
        to the outfitters checkout and advise them that you placed a counter
        order for photos.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Counter",

  data() {
    return {};
  },
  methods: {
    handleBack() {
      this.$store.dispatch("order/clear_order").then(() => {
        this.$store.dispatch("search/clear_displayGroups").then(() => {
          this.$router.push("/outfitter/" + this.outfitter.slug);
        });
      });
    },
  },
  computed: {
    outfitter: function () {
      return this.$store.getters["search/getOutfitter"];
    },
  },
  mounted() {
    localStorage.removeItem("wwp-orderId");
    localStorage.removeItem("wwp-order-time");
  },
};
</script>
